// Mock conversations data
export const mockConversations = {
  '1': {
    id: '1',
    title: 'Iscrizione scuola elementare per Sofia',
    messages: [
      {
        id: 'm1',
        type: 'user' as const,
        content: 'Devo iscrivere Sofia alla scuola elementare, da dove inizio?',
        timestamp: new Date('2024-01-15T09:00:00'),
      },
      {
        id: 'm2',
        type: 'assistant' as const,
        content:
          "Perfetto! L'iscrizione alla scuola elementare è un momento importante. Ti aiuto a organizzare tutto passo dopo passo. Hai già scelto la scuola?",
        timestamp: new Date('2024-01-15T09:00:30'),
      },
      {
        id: 'm3',
        type: 'user' as const,
        content: 'Sì, la scuola Manzoni vicino a casa',
        timestamp: new Date('2024-01-15T09:01:00'),
      },
      {
        id: 'm4',
        type: 'assistant' as const,
        content:
          "Ottima scelta! Ho preparato una checklist completa con tutti i documenti necessari e i passaggi per l'iscrizione alla scuola elementare.",
        timestamp: new Date('2024-01-15T09:01:30'),
        tasks: [
          {
            id: 't1',
            title: 'Iscrizione Scuola Elementare - Sofia',
            category: 'Scuola',
            categoryColor: '#AEDAFF',
            items: [
              {
                id: 'task1',
                text: 'Registrazione portale MIUR',
                completed: true,
              },
              {
                id: 'task2',
                text: 'Codice meccanografico scuola Manzoni',
                completed: true,
              },
              {
                id: 'task3',
                text: 'Certificato vaccinazioni aggiornato',
                completed: false,
              },
              {
                id: 'task4',
                text: 'Codice fiscale Sofia',
                completed: true,
              },
              {
                id: 'task5',
                text: 'Compilare domanda online entro 31 gennaio',
                completed: false,
              },
              {
                id: 'task6',
                text: 'Allegare documento identità genitore',
                completed: false,
              },
              {
                id: 'task7',
                text: 'Scegliere tempo scuola (tempo pieno/modulo)',
                completed: false,
              },
              {
                id: 'task8',
                text: 'Confermare iscrizione via email',
                completed: false,
              },
            ],
          },
        ],
      },
    ],
  },
  '2': {
    id: '2',
    title: 'Rinnovo passaporto per Marco',
    messages: [
      {
        id: 'm1',
        type: 'user' as const,
        content: 'Il passaporto di Marco scade tra 3 mesi, devo rinnovarlo',
        timestamp: new Date('2024-01-12T14:00:00'),
      },
      {
        id: 'm2',
        type: 'assistant' as const,
        content:
          'Ottimo che tu ci stia pensando in anticipo! Il rinnovo del passaporto per minori richiede alcuni documenti specifici. Ti preparo due checklist: una per i documenti da raccogliere e una per i passaggi burocratici.',
        timestamp: new Date('2024-01-12T14:00:30'),
        tasks: [
          {
            id: 't1',
            title: 'Documenti Passaporto Marco',
            category: 'Burocrazia',
            categoryColor: '#FAD88A',
            items: [
              {
                id: 'task1',
                text: 'Carta identità Marco (originale + fotocopia)',
                completed: true,
              },
              {
                id: 'task2',
                text: 'Documenti identità entrambi i genitori',
                completed: true,
              },
              {
                id: 'task3',
                text: '2 foto tessera recenti (fondo bianco)',
                completed: false,
              },
              {
                id: 'task4',
                text: 'Codice fiscale Marco',
                completed: true,
              },
            ],
          },
          {
            id: 't2',
            title: 'Passaggi Burocratici',
            category: 'Burocrazia',
            categoryColor: '#FAD88A',
            items: [
              {
                id: 'task5',
                text: 'Prenotare appuntamento in Questura',
                completed: false,
              },
              {
                id: 'task6',
                text: 'Pagare marca da bollo €73.50',
                completed: false,
              },
              {
                id: 'task7',
                text: 'Compilare modulo assenso genitori',
                completed: false,
              },
              {
                id: 'task8',
                text: 'Presenza entrambi genitori (o delega)',
                completed: false,
              },
            ],
          },
        ],
      },
      {
        id: 'm3',
        type: 'user' as const,
        content: 'Perfetto, grazie! Quanto tempo ci vuole per averlo?',
        timestamp: new Date('2024-01-12T14:02:00'),
      },
      {
        id: 'm4',
        type: 'assistant' as const,
        content:
          "Di solito ci vogliono 2-3 settimane dalla data dell'appuntamento. Ti consiglio di prenotare subito così sei tranquilla! 😊",
        timestamp: new Date('2024-01-12T14:02:15'),
      },
    ],
  },
  '3': {
    id: '3',
    title: 'Cambio pediatra per Sofia',
    messages: [
      {
        id: 'm1',
        type: 'user' as const,
        content: 'Devo cambiare il pediatra di Sofia, cosa devo fare?',
        timestamp: new Date('2024-01-10T10:00:00'),
      },
      {
        id: 'm2',
        type: 'assistant' as const,
        content:
          'Capisco, cambiare pediatra richiede alcuni passaggi. Ti aiuto a organizzare tutto! Prima di tutto, hai già scelto il nuovo pediatra?',
        timestamp: new Date('2024-01-10T10:00:30'),
      },
      {
        id: 'm3',
        type: 'user' as const,
        content:
          'Sì, ho trovato la Dottoressa Rossi che ha lo studio vicino a casa',
        timestamp: new Date('2024-01-10T10:01:00'),
      },
      {
        id: 'm4',
        type: 'assistant' as const,
        content:
          'Perfetto! Ho preparato una checklist completa per il cambio pediatra. Include tutti i documenti necessari e i passaggi da seguire.',
        timestamp: new Date('2024-01-10T10:01:30'),
        tasks: [
          {
            id: 't1',
            title: 'Cambio Pediatra - Sofia',
            category: 'Salute',
            categoryColor: '#B0EC9C',
            items: [
              {
                id: 'task1',
                text: 'Richiedere revoca dal pediatra attuale',
                completed: true,
              },
              {
                id: 'task2',
                text: 'Ottenere tessera sanitaria di Sofia',
                completed: true,
              },
              {
                id: 'task3',
                text: 'Prenotare appuntamento ASL per cambio',
                completed: false,
              },
              {
                id: 'task4',
                text: 'Portare documento identità genitore',
                completed: false,
              },
              {
                id: 'task5',
                text: 'Confermare disponibilità Dott.ssa Rossi',
                completed: false,
              },
            ],
          },
        ],
      },
    ],
  },
  '4': {
    id: '4',
    title: 'Iscrizione corso di nuoto per Marco',
    messages: [
      {
        id: 'm1',
        type: 'user' as const,
        content: 'Vorrei iscrivere Marco al corso di nuoto',
        timestamp: new Date('2024-01-08T16:00:00'),
      },
      {
        id: 'm2',
        type: 'assistant' as const,
        content:
          "Che bella idea! Il nuoto è un'attività completa per i bambini. Hai già scelto la piscina?",
        timestamp: new Date('2024-01-08T16:00:30'),
      },
      {
        id: 'm3',
        type: 'user' as const,
        content: 'Sì, la piscina comunale, corso principianti',
        timestamp: new Date('2024-01-08T16:01:00'),
      },
      {
        id: 'm4',
        type: 'assistant' as const,
        content:
          "Perfetto! Ti preparo la checklist con tutto ciò che serve per l'iscrizione al corso di nuoto.",
        timestamp: new Date('2024-01-08T16:01:30'),
        tasks: [
          {
            id: 't1',
            title: 'Iscrizione Corso Nuoto - Marco',
            category: 'Sport',
            categoryColor: '#DDD6FE',
            items: [
              {
                id: 'task1',
                text: 'Certificato medico sportivo non agonistico',
                completed: false,
              },
              {
                id: 'task2',
                text: 'Modulo iscrizione compilato',
                completed: false,
              },
              {
                id: 'task3',
                text: 'Pagamento quota corso (€180)',
                completed: false,
              },
              {
                id: 'task4',
                text: 'Acquistare costume, cuffia e ciabatte',
                completed: false,
              },
            ],
          },
        ],
      },
    ],
  },
  '5': {
    id: '5',
    title: 'Documenti per gita scolastica',
    messages: [
      {
        id: 'm1',
        type: 'user' as const,
        content: 'Sofia ha la gita scolastica, quali documenti servono?',
        timestamp: new Date('2024-01-05T11:00:00'),
      },
      {
        id: 'm2',
        type: 'assistant' as const,
        content:
          'Le gite scolastiche richiedono alcuni documenti importanti. Dove andrà Sofia?',
        timestamp: new Date('2024-01-05T11:00:30'),
      },
      {
        id: 'm3',
        type: 'user' as const,
        content: 'A Firenze, 2 giorni con pernottamento',
        timestamp: new Date('2024-01-05T11:01:00'),
      },
      {
        id: 'm4',
        type: 'assistant' as const,
        content:
          'Ottimo! Per una gita con pernottamento servono alcuni documenti specifici. Ecco la checklist completa.',
        timestamp: new Date('2024-01-05T11:01:30'),
        tasks: [
          {
            id: 't1',
            title: 'Documenti Gita Scolastica - Sofia',
            category: 'Scuola',
            categoryColor: '#AEDAFF',
            items: [
              {
                id: 'task1',
                text: 'Autorizzazione firmata da entrambi i genitori',
                completed: true,
              },
              {
                id: 'task2',
                text: 'Fotocopia documento identità Sofia',
                completed: false,
              },
              {
                id: 'task3',
                text: 'Pagamento quota gita (€150)',
                completed: false,
              },
            ],
          },
        ],
      },
    ],
  },
  '6': {
    id: '6',
    title: 'Visita oculistica per Marco',
    messages: [
      {
        id: 'm1',
        type: 'user' as const,
        content: 'Marco deve fare una visita oculistica, come prenoto?',
        timestamp: new Date('2024-01-03T15:00:00'),
      },
      {
        id: 'm2',
        type: 'assistant' as const,
        content:
          'Ti aiuto a organizzare la visita oculistica per Marco. È una visita di controllo o ha qualche problema specifico?',
        timestamp: new Date('2024-01-03T15:00:30'),
      },
      {
        id: 'm3',
        type: 'user' as const,
        content: "Controllo di routine, l'ultima visita è stata 2 anni fa",
        timestamp: new Date('2024-01-03T15:01:00'),
      },
      {
        id: 'm4',
        type: 'assistant' as const,
        content:
          'Perfetto! Ecco tutti i passaggi per prenotare e prepararsi alla visita oculistica.',
        timestamp: new Date('2024-01-03T15:01:30'),
        tasks: [
          {
            id: 't1',
            title: 'Visita Oculistica - Marco',
            category: 'Salute',
            categoryColor: '#B0EC9C',
            items: [
              {
                id: 'task1',
                text: 'Richiedere impegnativa al pediatra',
                completed: true,
              },
              {
                id: 'task2',
                text: 'Prenotare visita CUP o privato',
                completed: false,
              },
              {
                id: 'task3',
                text: 'Portare tessera sanitaria Marco',
                completed: false,
              },
              {
                id: 'task4',
                text: 'Portare eventuali occhiali precedenti',
                completed: false,
              },
            ],
          },
        ],
      },
    ],
  },
}
